import { SUPPORTED_MAJOR_VERSION } from './constants';
export var validateSessionInfo = function (maybeSession) {
    return typeof maybeSession === 'object' &&
        maybeSession !== null &&
        typeof maybeSession.sessionId === 'string' &&
        typeof maybeSession.sessionStartTime === 'number';
};
export var validateSharedParameters = function (maybeSharedParameters) {
    var stringParameters = [
        'client',
        'clientVersion',
        'clientBundle',
        'deviceId',
        'osName',
        'sessionId',
    ];
    var numberParameters = ['sessionStartTime'];
    return (typeof maybeSharedParameters === 'object' &&
        stringParameters.every(function (key) { return typeof maybeSharedParameters[key] === 'string'; }) &&
        numberParameters.every(function (key) { return typeof maybeSharedParameters[key] === 'number'; }));
};
export var validateVersion = function (maybeVersion) {
    if (typeof maybeVersion !== 'string') {
        return false;
    }
    var segments = maybeVersion.split('.');
    if (segments.length !== 2) {
        return false;
    }
    var minorVersion = Number(segments[1]);
    return segments[0] === SUPPORTED_MAJOR_VERSION && Number.isFinite(minorVersion);
};
//# sourceMappingURL=utils.js.map